// Match API UserType enum from apps/api/src/modules/users/schemas/user.schema.ts
export enum UserType {
  ADMIN = 1,
  USER = 2,
  PARTNER = 3,
}

// Match API LoginProvider enum
export enum LoginProvider {
  COGNITO = 1,
  GOOGLE = 2,
  APPLE = 3,
}

// API User document structure (relevant fields for admin)
export interface ApiUser {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  countryCode: string;
  isVerified: boolean;
  cognitoId: string;
  type: UserType;
  isTermsAccepted: boolean;
  provider: LoginProvider;
  createdAt: string;
  updatedAt: string;
}

// API wrapper response structure
export interface ApiResponse<T> {
  result: T;
  status: number;
  message: string;
  error: null | { code: number; message: string; issues: unknown[] };
}

// Login response data (inside result)
export interface LoginResponseData {
  user: ApiUser;
}

// Login response from POST /auth/login
export type LoginResponse = ApiResponse<LoginResponseData>;

// Me response data (inside result)
export interface MeResponseData {
  user: ApiUser;
}

// Me response from GET /auth/me
export type MeResponse = ApiResponse<MeResponseData>;

// CSRF token response from GET /auth/csrf-token
export interface CsrfResponse {
  csrfToken: string;
}

// API error response structure
export interface ApiError {
  statusCode: number;
  message: string;
  error?: string;
}

// Login credentials
export interface LoginCredentials {
  email: string;
  password: string;
}

// Auth error codes
export type AuthErrorCode =
  | 'INVALID_CREDENTIALS'
  | 'NOT_ADMIN'
  | 'SESSION_EXPIRED'
  | 'NETWORK_ERROR'
  | 'UNKNOWN';
